<template>
  <div class="output-page">
    <div class="title">作业管理__输出文件</div>
    <div class="page-handle">
      <a-row>
        <a-col :span="8">
          <a-button @click="triggerLay" type="primary">设置发送字段</a-button>
          <!--<a-button @click="triggerStatus(0)" type="primary">加入</a-button>-->
          <a-button @click="triggerStatus(1)" type="primary">不加入</a-button>
        </a-col>
        <a-col :span="16" class="align-right">
          <a-dropdown v-if="fileType != 'cnv' " overlayClassName="hospital-dropdown-overlay"
            class="hospital-dropdown-link">
            <a class="ant-dropdown-link">
              {{ variantClassText }}
              <a-icon type="down" />
            </a>
            <a-menu style="height: 200px; overflow: auto" @click="checkVariantClass" slot="overlay">
              <a-menu-item key="全部">全部</a-menu-item>
              <a-menu-item v-for="item in variantClassList" :key="item.key">{{
              item.name
              }}</a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">
            <a class="ant-dropdown-link">
              {{ userNameText }}
              <a-icon type="down" />
            </a>
            <a-menu style="height: 200px; overflow: auto" @click="checkUser" slot="overlay">
              <a-menu-item v-for="item in userList" :key="item.userId">{{
              item.nickname
              }}</a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-select mode="multiple" placeholder="请选择 Level" :value="selectedLevelItems" class="hp-multiple-slt"
            @change="changeLevel">
            <a-select-option v-for="item in levelOptions" :key="item.key" :value="item.key">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-select mode="multiple" placeholder="操作状态" :value="selectedStatusItems" class="hp-multiple-slt"
            @change="changeStatus">
            <a-select-option v-for="item in statusList" :key="item.key" :value="item.key">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <!-- <a-dropdown
            overlayClassName="hospital-dropdown-overlay"
            class="hospital-dropdown-link"
          >
            <a class="ant-dropdown-link">
              {{ statusText }}
              <a-icon type="down" />
            </a>
            <a-menu
              style="height: 200px; overflow: auto"
              @click="checkStatus"
              slot="overlay"
            >
              <a-menu-item key="操作状态">全部</a-menu-item>
              <a-menu-item v-for="item in statusList" :key="item.key">{{
                item.name
              }}</a-menu-item>
            </a-menu>
          </a-dropdown> -->

          <a-button v-if="fileType!='cnv'" style="margin-left: 10px" @click="triggerSearch" class="query-cbox">搜索
            <a-icon type="search" />
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="page-trigger-lay" v-show="triggerVisible">
      <div class="lay-content">
        <a-button @click="queryAll" class="query-cbox">{{
        queryAllText
        }}</a-button>
        <a-checkbox class="cbox-left" v-for="item in columnsAry" :key="item.key"
          @change="(checkedValue) => onChange(checkedValue, item)" :checked="item.checked" :disabled="item.disabled">{{
          item.key }}
        </a-checkbox>
      </div>
      <div class="lay-bottom">
        <a-button @click="confirmLay" type="primary">确定</a-button>
      </div>
    </div>
    <div class="page-trigger-search" v-show="triggerSearchVisible">
      <div class="lay-content">
        <a-row v-if="fileType == 'snp' || fileType == 'indel'" class="lay-c-search">
          <a-col :span="4">Gene_Symbol</a-col>
          <a-col :span="6">
            <a-input v-model="queryGS" placeholder="请输入Gene_symbol" />
          </a-col>
          <a-col :span="4"></a-col>
          <a-col :span="4">Consequence</a-col>
          <a-col :span="6">
            <a-input v-model="queryC" placeholder="请输入Consequence" />
          </a-col>
        </a-row>
        <template v-else-if="fileType == 'fusion'">
          <a-row class="lay-c-search">
            <a-col :span="6">Gene_1_symbol(5end_fusion_partner)</a-col>
            <a-col :span="5">
              <a-input v-model="queryG1S" placeholder="请输入Gene_1_symbol(5end_fusion_partner)" />
            </a-col>
            <a-col :span="2"></a-col>
            <a-col :span="6">Gene_2_symbol(3end_fusion_partner)</a-col>
            <a-col :span="5">
              <a-input v-model="queryG2S" placeholder="请输入Gene_2_symbol(3end_fusion_partner)" />
            </a-col>
          </a-row>
          <a-row class="lay-c-search">
            <a-col :span="6">Fusion_description</a-col>
            <a-col :span="5">
              <a-input v-model="queryFD" placeholder="请输入Fusion_description" />
            </a-col>
          </a-row>
        </template>
        <template v-else>
          <a-row class="lay-c-search">
            <a-col :span="6">geneA</a-col>
            <a-col :span="5">
              <a-input v-model="queryGA" placeholder="请输入geneA" />
            </a-col>
            <a-col :span="2"></a-col>
            <a-col :span="6">geneB</a-col>
            <a-col :span="5">
              <a-input v-model="queryGB" placeholder="请输入geneB" />
            </a-col>
          </a-row>
          <a-row class="lay-c-search">
            <a-col :span="6">type</a-col>
            <a-col :span="5">
              <a-input v-model="queryType" placeholder="请输入type" />
            </a-col>
            <a-col :span="2"></a-col>
            <a-col :span="6">rating</a-col>
            <a-col :span="5">
              <a-input v-model="queryRating" placeholder="请输入rating" />
            </a-col>
          </a-row>
          <a-row class="lay-c-search">
            <a-col :span="6">functional effect</a-col>
            <a-col :span="5">
              <a-input v-model="queryFE" placeholder="请输入functional effect" />
            </a-col>
          </a-row>
        </template>
      </div>
      <div class="lay-bottom">
        <a-button @click="onSearch" type="primary">确定</a-button>
        <a-button style="margin-left: 20px" @click="onResetting">重置</a-button>
      </div>
    </div>
    <div class="page-content">
      <a-table class="hospital-table output-table" :style="{ wordBreak: 'break-all' }" :columns="columns"
        :dataSource="data" :rowSelection="optFileStatus != 3 ? rowSelection : null" bordered
        :scroll="{ x: columnsWidth, y: 560 }" :pagination="false" :loading="loading" :locale="{ emptyText: '暂无数据' }"
        :rowKey="(record) => record.id" size="middle">
        <template v-for="col in columns" :slot="col.key" slot-scope="text, record">
          <div :key="col.key">
            <a-input v-if="record.source != undefined && record.editable" :value="text"
              @blur="(e) => handleChange(e, record.id, col)" class="edit_input_width" type="text" placeholder="请输入值" />
            <template v-else-if="
              col.key == 'Pos' ||
              col.key == 'posA' ||
              col.key == 'posB' ||
              col.key == 'Fusion_point_for_gene_1(5end_fusion_partner)' ||
              col.key == 'Fusion_point_for_gene_2(3end_fusion_partner)'
            ">
              <div @click="keshihuaClick(record)" class="link">{{ text }}</div>
            </template>
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template slot-scope="text, record" slot="Status">
          <span>{{ getStatusText(record.Status) }}</span>
        </template>
        <template slot-scope="text, record" class="table-tr-handle" slot="action">
          <div style="width: 95px" class="down-list">
            <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-show="showTable"
              :class="{ 'has-error': isSubmit && !isOkStatus(record) }" placeholder="请选择" style="width: 95px"
              @click="stopPropagation(e)" @change="rowChange($event, record)" v-model="record.rowStatus">
              <a-select-option value="-1">复制-插入</a-select-option>
              <a-select-option v-for="item in statusList" :key="item.key" v-if="item.key != 5" :value="item.key">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </template>
      </a-table>
      <div style="margin: 15px 0; text-align: center" v-if="pages > 0" class="button-group">
        <div class="bg-total">共{{ currentTotal }}/{{ total }}条</div>
        <span class="link" v-if="pages != current" @click="loadPageData">加载更多</span>
      </div>
      <div v-if="step === 1" style="margin: 30px 0" class="button-group">
        <a-button @click="saveClick" :disabled="
          !record.editable ||
          jobDetail.verifyStatus == '1' ||
          jobDetail.verifyStatus == '3' ||
          (userInfo.userId != jobDetail.submitterId &&
            userInfo.userId != jobDetail.verifyId)
        " type="primary">保存
        </a-button>
        <!-- :disabled="step!=1||record.optFileStatus==2" -->
        <a-button :disabled="
          !record.editable ||
          jobDetail.verifyStatus == '1' ||
          jobDetail.verifyStatus == '3' ||
          (userInfo.userId != jobDetail.submitterId &&
            userInfo.userId != jobDetail.verifyId)
        " @click="submitClick" style="margin-left: 21px">提交
        </a-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <page-model @close="closeModel" :visible="visible">
      <appoint v-if="visible && isAppoint == 1" @close="closeModel"></appoint>
    </page-model>
    <a-modal :closable="false" wrapClassName="fusion-visual-demo" title="Basic Modal" v-model="fusionVisible">
      <fusion-visual-demo :record.sync="fusionReccord"></fusion-visual-demo>
    </a-modal>
  </div>
</template>

<script>
import Appoint from "./appoint";
import FusionVisualDemo from "./fusion-visual-demo";
import { uuid32 } from "../../common/common";
import db from "@/common/localstorage";

export default {
  data() {
    return {
      loading: false,
      userId: 0,
      userInfo: {},
      queryL: "",
      queryS: "",
      queryVC: "",
      queryGS: "",
      queryC: "",
      queryG1S: "",
      queryG2S: "",
      queryFD: "",
      queryGA: "",
      queryGB: "",
      queryType: "",
      queryRating: "",
      queryFE: "",
      allData: [],
      data: [],
      optFileStatus: 0,
      fusionReccord: {
        data1: {
          label: "",
          chromosome: "",
          position: "",
        },
        data2: {
          label: "",
          chromosome: "",
          position: "",
        },
      },
      allColumns: [],
      columns: [],
      columnsWidth: 0,
      statusList: [
        { key: 5, name: "空" },
        { key: 0, name: "加入P" },
        { key: 6, name: "加入LP" },
        { key: 7, name: "加入VUS" },
        { key: 8, name: "加入LB" },
        { key: 9, name: "加入B" },
        { key: 1, name: "不加入" },
        // {key: 2, name: '待审核'},
        { key: 3, name: "待讨论" },
        { key: 4, name: "删除" },
      ],
      variantClassList: [
        { key: "snv", name: "snv" },
        { key: "indel", name: "indel" },
      ],
      levelOptions: [
        { key: "L1", name: "L1" },
        { key: "L2", name: "L2" },
        { key: "L3", name: "L3" },
        { key: "L4", name: "L4" },
        { key: "L5", name: "L5" },
      ],
      fileType: "fusion",
      statusText: "操作状态",
      levelText: "level",
      selectedLevelItems: [],
      selectedStatusItems: [],
      variantClassText: "VARIANT_CLASS",
      userNameText: "全部",
      queryAllText: "不全选",
      queryAllStatus: false,
      outputFilePaths: null,
      defaultNo: {
        title: "NO",
        key: "N01",
        width: 80,
        //customRender: (text, record, index) => `${index + 1}`,
        customRender: (text, record, index) => {
          return record.id.substring(record.id.length - 8);
        },
        // scopedSlots: {customRender: "recordIndex"}
      },
      defaultStatus: {
        title: "Status",
        key: "Status",
        width: 60,
        dataIndex: "Status",
        scopedSlots: { customRender: "Status" },
      },
      textData: [],
      insertData: {},
      updateData: {},
      titleData: {},
      saveTitleData: {},
      userList: [],
      jobsFileRefId: "",
      isSubmit: false,
      visible: false,
      triggerVisible: false,
      triggerSearchVisible: false,
      fusionVisible: false,
      isAppoint: false,
      columnsAry: [],
      showTable: false,
      pageSize: 100,
      pages: 1,
      current: 1,
      total: 0,
      currentTotal: 0,
      selectedData: [],
      selectedRowKeys: [],
      selectRows: {},
    };
  },
  props: {
    jobId: {
      type: String,
      default: "",
    },
    verifyId: {
      type: String,
      default: "",
    },
    record: {
      type: Object,
      default: () => { },
    },
    jobDetail: {
      type: Object,
      default: () => { },
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Appoint,
    FusionVisualDemo,
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedData = selectedRows;
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name,
          },
        }),
      };
    },
  },
  mounted() {
    this.optFileStatus = this.record.optFileStatus;
    this.userInfo = db.get("userInfo") || {};
    this.userId = this.$db.get("userInfo").userId;
    this.getOptUserList();
    this.getTextData();
    if (this.record.fileType && !this.findFileType(this.record.fileType)) {
      this.getOutFilePaths();
    }
    if (this.record.fileType && this.findFileType(this.record.fileType)) {
      this.fileType = "cnv";
    } else if (this.record.fileType && this.record.fileType == "cicero") {
      this.fileType = "cicero";
    } else if (this.record.fileType && this.record.fileType == "fusion") {
      this.fileType = "fusion";
    } else if (this.record.fileType && this.record.fileType == "indel") {
      this.fileType = "indel";
    } else {
      this.fileType = "snp";
    }
  },
  methods: {
    findFileType(val) {
      let fileType = ['cnv', 'panel_snp', 'sv', 'wes_snp', 'wes_sv', 'large'];
      let bool = false;
      if (fileType.indexOf(val) != -1) {
        bool = true;
      }
      return bool;
    },
    getStatusText(key) {
      let name = "-";
      if (key !== "" && key !== "-") {
        this.statusList.forEach((val, i) => {
          if (val.key === key) {
            name = val.name;
            return;
          }
        });
      }
      return name;
    },
    onSearch() {
      //this.triggerSearchVisible = !this.triggerSearchVisible;
      this.columns = [];
      this.getTextData();
    },
    onResetting() {
      this.queryGS = "";
      this.queryC = "";
      this.queryG1S = "";
      this.queryG2S = "";
      this.queryFD = "";
      this.queryGA = "";
      this.queryGB = "";
      this.queryType = "";
      this.queryRating = "";
      this.queryFE = "";
    },
    triggerLay() {
      this.triggerSearchVisible = false;
      this.triggerVisible = !this.triggerVisible;
    },
    triggerStatus(status) {
      if (this.selectedData.length == 0) {
        this.$message.error("请至少选择一条数据进行操作");
      } else {
        this.selectedData.forEach((item) => {
          this.rowChange(status, item);
          // item.Status = status;
          // item.rowStatus = status;
        });
      }
    },
    triggerSearch() {
      this.triggerVisible = false;
      this.triggerSearchVisible = !this.triggerSearchVisible;
    },
    confirmLay() {
      this.triggerVisible = !this.triggerVisible;
      this.refreshColumns();
    },
    queryAll() {
      if (this.queryAllStatus) {
        this.queryAllStatus = false;
        this.queryAllText = "反全选";
        this.columnsAry.forEach((item) => {
          if (!item.disabled) {
            item.checked = true;
            this.titleData[item.key] = 1;
          }
        });
      } else {
        this.queryAllStatus = true;
        this.queryAllText = "全选";
        this.columnsAry.forEach((item) => {
          if (!item.disabled) {
            item.checked = false;
            this.titleData[item.key] = 0;
          }
        });
      }
    },
    getTitleHideSize() {
      let size = 0;
      Object.keys(this.titleData).forEach((key) => {
        if (!this.titleData[key]) {
          size += 1;
        }
      });
      return size;
    },
    getOptUserList() {
      //api/jobsvisualization/efu/{fileUrl}
      this.$get("jobsvisualization/efu?fileUrl=" + this.record.fileUrl).then(
        (res) => {
          if (res.data.data) {
            this.userList = res.data.data;
            this.userList.forEach((item) => {
              if (item.userId == this.userId) {
                this.userNameText = item.nickname;
              }
            });
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },
    keshihuaClick(record) {
      if (this.record.fileType && this.record.fileType == "fusion") {
        let data1 = record["Fusion_point_for_gene_1(5end_fusion_partner)"];
        let data2 = record["Fusion_point_for_gene_2(3end_fusion_partner)"];
        if (data1 && data2) {
          this.fusionReccord = {
            data1: {
              label: data1,
              chromosome: data1.split(":")[0],
              position: parseInt(data1.split(":")[1]),
            },
            data2: {
              label: data2,
              chromosome: data2.split(":")[0],
              position: parseInt(data2.split(":")[1]),
            },
          };
          this.fusionReccord = Object.assign(
            {},
            this.fusionReccord,
            this.outputFilePaths
          );
          this.fusionVisible = true;
        }
      } else if (this.record.fileType && this.record.fileType == "cicero") {
        let chr1 = record["chrA"];
        let data1 = record["posA"];
        let chr2 = record["chrB"];
        let data2 = record["posB"];
        if (data1 && data2) {
          this.fusionReccord = {
            data1: {
              label: chr1 + ":" + data1,
              chromosome: chr1.split("r")[1],
              position: parseInt(data1),
            },
            data2: {
              label: chr2 + ":" + data2,
              chromosome: chr2.split("r")[1],
              position: parseInt(data2),
            },
          };
          this.fusionReccord = Object.assign(
            {},
            this.fusionReccord,
            this.outputFilePaths
          );
          this.fusionVisible = true;
        }
      } else {
        let data1 = record["Chr"];
        let data2 = record["Pos"];
        if (data1 && data2) {
          this.fusionReccord = {
            data1: {
              label: data1 + ":" + data2,
              chromosome: data1.split("r")[1],
              position: parseInt(data2),
            },
            data2: {
              label: data1 + ":" + data2,
              chromosome: data1.split("r")[1],
              position: parseInt(data2),
            },
          };
          this.fusionReccord = Object.assign(
            {},
            this.fusionReccord,
            this.outputFilePaths
          );
          this.fusionVisible = true;
        }
      }
    },
    // 选择用户
    checkUser({ key }) {
      if (key == "全部") {
        this.userNameText = "全部";
      } else {
        this.userList.forEach((item) => {
          if (item.userId == key) {
            this.userNameText = item.nickname;
            return;
          }
        });
        this.columns = [];
        this.userId = key;
        this.getTextData();
      }
    },
    checkVariantClass({ key }) {
      if (key != "全部") {
        this.variantClassList.forEach((item) => {
          if (item.key == key) {
            this.variantClassText = item.name;
            return;
          }
        });
        this.queryVC = key;
      } else {
        this.queryVC = "";
        this.variantClassText = "VARIANT_CLASS";
      }
      this.columns = [];
      this.getTextData();
    },
    // 选择状态
    // checkStatus({ key }) {
    //   if (key != "操作状态") {
    //     this.statusList.forEach((item) => {
    //       if (item.key == key) {
    //         this.statusText = item.name;
    //         return;
    //       }
    //     });
    //     if (key == 5) {
    //       this.queryS = "-";
    //     } else {
    //       this.queryS = key;
    //     }
    //   } else {
    //     this.queryS = "";
    //     this.statusText = "操作状态";
    //   }
    //   this.columns = [];
    //   this.getTextData();
    // },
    // 多选择状态
    changeStatus(selectedStatusItems) {
      this.queryS = selectedStatusItems.join(",");
      this.selectedStatusItems = selectedStatusItems;
      this.columns = [];
      this.getTextData();
    },
    // 多选择级别
    changeLevel(selectedLevelItems) {
      this.queryL = selectedLevelItems.join(",");
      this.selectedLevelItems = selectedLevelItems;
      this.columns = [];
      this.getTextData();
    },
    // 选择级别
    // checkLevel({ key }) {
    //   this.levelText = key;
    //   if (key != "Level") {
    //     this.queryL = key;
    //   } else {
    //     this.queryL = "";
    //   }
    //   this.columns = [];
    //   this.getTextData();
    // },
    // 数据过滤
    filterData(key, name) {
      var result = [];
      this.allData.forEach((item) => {
        if (item[name] == key) {
          result.push(item);
        }
      });
      this.data = result.concat([]);
    },
    // 提交验证
    isOkStatus(item) {
      if (item.Level == "L1" || item.Level == "L2") {
        if (
          item.rowStatus == "0" ||
          item.rowStatus == "1" ||
          item.rowStatus == "6" ||
          item.rowStatus == "7" ||
          item.rowStatus == "8" ||
          item.rowStatus == "9"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    checkTableData() {
      let result = false;
      this.allData.forEach((item) => {
        if (item.Level == "L1" || item.Level == "L2") {
          if (
            item.rowStatus != "0" &&
            item.rowStatus != "1" &&
            item.rowStatus != "6" &&
            item.rowStatus != "7" &&
            item.rowStatus != "8" &&
            item.rowStatus != "9"
          ) {
            result = true;
          }
        }
      });
      return result;
    },

    // 创建保存数据
    createSaveData() {
      let result = [];
      let header = [];
      this.allColumns.forEach((item) => {
        if (!item.dataIndex) return;
        if (item.dataIndex == "rowStatus") {
          header.push("操作");
        } else if (item.dataIndex) {
          header.push(item.dataIndex);
        }
      });
      result.push(header);
      this.allData.forEach((item) => {
        let body = [];
        result[0].forEach((name) => {
          if (name == "操作") {
            body.push(item.rowStatus);
          } else {
            body.push(item[name]);
          }
        });
        result.push(body);
      });
      return result;
    },
    getSaveData() {
      let result = {};
      result.uecJobsVisual = {
        id: this.textData.uecJobsVisual.id,
        titles: JSON.stringify(this.titleData),
      };
      result.insertList = this.filterInsertUpdateData(this.insertData);
      result.updateList = this.filterInsertUpdateData(this.updateData);
      return result;
    },
    filterInsertUpdateData(IUData) {
      let result = [];
      if (this.data && this.data.length > 0 && JSON.stringify(IUData) != "{}") {
        this.data.forEach((item, i) => {
          if (IUData[item.id] != undefined) {
            let json = {
              id: item.id,
              data: JSON.stringify(item),
            };
            result.push(json);
          }
        });
      }
      return result;
    },
    // 保存点击
    saveClick() {
      this.$post(
        "cloudPlatformApi/saveJsonToDraft?operationType=1&jobsFileRefId=" +
        this.record.id,
        this.getSaveData(),
        true,
        {
          "Content-Type": "application/json",
        }
      ).then((res) => {
        this.$message.success("操作成功!");
        // this.$emit("close");
      });
    },
    // 提交事件
    submitClick() {
      // if (this.verifyId == null || this.verifyId == "") {
      //   this.$message.error("请选择指派人");
      // } else {
      this.isSubmit = true;
      this.$nextTick(() => {
        var errList = document.querySelectorAll(".has-error");
        // console.log(this.createSubmitData(),this.checkTableData());
        if (this.checkTableData()) {
          this.$message.error(
            "Level为L1和L2的数据的操作状态必须为加入或不加入"
          );
          return;
        }
        if (errList.length == 0) {
          this.$post(
            "cloudPlatformApi/saveJsonToDraft?operationType=2&jobsFileRefId=" +
            this.record.id,
            this.getSaveData(),
            true,
            {
              "Content-Type": "application/json",
            }
          ).then((res) => {
            if (res.data.code == 0) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("操作成功!");
              this.$emit("close");
            }
          });
        } else {
          this.$message.error("级别为L1和L2的数据操作状态必须为加入或不加入");
        }
      });
      // }
    },
    // 阻止冒泡
    stopPropagation(e) {
      e.stopPropagation();
      e.cancelBubble = true;
    },
    handleChange(e, key, column) {
      e.stopPropagation();
      let value = e.target.value;
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target[column.key] = value;
        this.data = newData;
      }
    },
    // 操作select onChange
    rowChange(val, row) {
      let $row = Object.assign({}, row, { editable: false });
      if (val == -1) {
        $row.id = uuid32();
        $row.source = row.id;
        $row.rowStatus = "";
        $row.editable = true;
        this.insertCopeData(row.id, $row);
        this.currentTotal = this.data.length;
        this.total = this.total + 1;
      } else {
        row.Status = val;
        row.rowStatus = val;
        if (
          this.findAddDataExistId(row.id) != "" &&
          this.findAddDataExistId(row.id) != undefined
        ) {
          this.insertData[row.id] = row;
        } else {
          this.updateData[row.id] = row;
        }
      }
    },
    insertCopeData(id, newRow) {
      let index = 0;
      this.data.forEach((item, i) => {
        if (id == item.id) {
          index = i + 1;
          return;
        }
      });
      this.insertData[newRow.id] = newRow;
      this.data.splice(index, 0, newRow);
      this.allData.splice(index, 0, newRow);
    },
    findAddDataExistId(id) {
      if (JSON.stringify(this.insertData) == "{}") {
        return "";
      } else {
        return this.insertData[id];
      }
    },
    onChange(e, item) {
      item.checked = e.target.checked;
      this.titleData[item.key] = item.checked == false ? 0 : 1;
      this.changeQueryAllStatus();
      // this.refreshColumns();
    },
    // 初始化数据设置列
    initSetColumns() {
      let result = [];
      let columnsTitle = this.titleData;
      if (JSON.stringify(columnsTitle) != "{}") {
        this.allColumns.forEach((item) => {
          if (columnsTitle[item.title] != 0) {
            result.push(item);
          }
        });
        this.columns = result.concat([]);
      }
    },
    // 刷新列
    refreshColumns() {
      let result = [this.defaultNo];
      this.allColumns.forEach((item) => {
        let d = this.columnsAry.find((d) => item.dataIndex == d.key);
        if (d && d.checked) {
          result.push(item);
        }
      });
      result.push(this.defaultStatus);
      //if (this.optFileStatus != 2) {
      result.push({
        title: "操作",
        fixed: "right",
        key: "rowStatus",
        width: 160,
        dataIndex: "rowStatus",
        scopedSlots: { customRender: "action" },
      });
      //}
      this.columns = result.concat([]);
      this.setColumnsWidth();
    },
    setColumnsWidth() {
      this.columnsWidth = 0;
      this.columns.map((obj) => {
        if (obj.width != undefined) {
          this.columnsWidth += obj.width;
        }
      });
    },
    changeQueryAllStatus() {
      if (this.getTitleHideSize() == 0) {
        this.queryAllText = "反全选";
        this.queryAllStatus = false;
      } else {
        this.queryAllText = "全选";
        this.queryAllStatus = true;
      }
    },
    // 创建列
    createColumns() {
      this.columns.push(this.defaultNo);
      if (this.textData) {
        let columnsTitle = this.textData.uecJobsVisual.titles
          ? JSON.parse(this.textData.uecJobsVisual.titles)
          : {};
        this.titleData = columnsTitle;
        this.changeQueryAllStatus();
        if (this.record.fileType && this.record.fileType == "fusion") {
          this.columnsAry = [];
          for (let colKey of Object.keys(columnsTitle)) {
            if (colKey == "操作") return;
            this.columnsAry.push({
              key: colKey,
              checked: columnsTitle[colKey] == 1 ? true : false,
              disabled:
                colKey == "Fusion_point_for_gene_1(5end_fusion_partner)" ||
                colKey == "Fusion_point_for_gene_2(3end_fusion_partner)" ||
                colKey == "Gene_1_symbol(5end_fusion_partner)" ||
                colKey == "Gene_2_symbol(3end_fusion_partner)" ||
                colKey == "Predicted_effect" ||
                colKey == "Level" ||
                colKey == "Remark",
            });
            if (
              colKey == "Fusion_point_for_gene_1(5end_fusion_partner)" ||
              colKey == "Fusion_point_for_gene_2(3end_fusion_partner)"
            ) {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 150,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else if (colKey == "Gene_1_symbol(5end_fusion_partner)") {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 150,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else if (colKey == "Gene_2_symbol(3end_fusion_partner)") {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 150,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else if (colKey == "Fusion_sequence") {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 350,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else if (colKey == "Fusion_description") {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 200,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 120,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            }
          }
        } else if (this.record.fileType && this.record.fileType == "cicero") {
          this.columnsAry = [];
          for (let colKey of Object.keys(columnsTitle)) {
            if (colKey == "操作") return;
            this.columnsAry.push({
              key: colKey,
              checked: columnsTitle[colKey] == 1 ? true : false,
              disabled:
                colKey == "chrA" ||
                colKey == "posA" ||
                colKey == "chrB" ||
                colKey == "posB" ||
                colKey == "geneA" ||
                colKey == "geneB" ||
                colKey == "Level" ||
                colKey == "Remark",
            });
            if (colKey == "posA" || colKey == "posB") {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 150,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else if (colKey == "contig" || colKey == "frame") {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 300,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else if (
              colKey == "sv_AA" ||
              colKey == "sv_desc" ||
              colKey == "sv_refseqA" ||
              colKey == "sv_refseqB" ||
              colKey == "sv_processing_exception" ||
              colKey == "sv_refseqA_codon" ||
              colKey == "sv_refseqA_anchor_type" ||
              colKey == "sv_refseqA_coding_base_number" ||
              colKey == "sv_refseqB_codon" ||
              colKey == "sv_refseqB_anchor_type" ||
              colKey == "sv_refseqB_coding_base_number" ||
              colKey == "sv_refseqB_AA_index" ||
              colKey == "sv_general_info"
            ) {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 680,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            } else {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 120,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            }
          }
        } else {
          this.columnsAry = [];
          for (let colKey of Object.keys(columnsTitle)) {
            if (colKey == "操作") return;
            this.columnsAry.push({
              key: colKey,
              checked: columnsTitle[colKey] == 1 ? true : false,
              disabled:
                colKey == "Pos" ||
                colKey == "Ref" ||
                colKey == "Chr" ||
                colKey == "Alt" ||
                colKey == "VARIANT_CLASS" ||
                colKey == "Ref_Count" ||
                colKey == "Alt_Count" ||
                colKey == "DP" ||
                colKey == "Consequence" ||
                colKey == "NTchange" ||
                colKey == "Amino_acids" ||
                colKey == "Level" ||
                colKey == "Remark",
            });
            if (colKey == "Pos") {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 120,
                dataIndex: colKey,
                // scopedSlots: {customRender: "keshihua"}
                scopedSlots: { customRender: colKey },
              });
            } else {
              this.columns.push({
                title: colKey,
                key: colKey,
                width: 120,
                dataIndex: colKey,
                scopedSlots: { customRender: colKey },
              });
            }
          }
        }
      }
      this.columns.push(this.defaultStatus);
      // if (this.optFileStatus != 2) {
      this.columns.push({
        title: "操作",
        fixed: "right",
        key: "rowStatus",
        width: 160,
        dataIndex: "rowStatus",
        scopedSlots: { customRender: "action" },
      });
      // }
      this.allColumns = this.columns;
      this.initSetColumns();
      this.setColumnsWidth();
      setTimeout(() => {
        this.createTableData();
      }, 500);
    },
    createTableData() {
      if (this.textData.page && this.textData.page.records.length == 0) {
        this.data = [];
        this.allData = this.data.concat([]);
      } else {
        this.data = [];
        this.textData.page.records.forEach((item, i) => {
          let jsonData = JSON.parse(item.data);
          // if (!jsonData.Status) {
          //   jsonData.Status = '-';
          // }
          if (jsonData.Status !== "" && jsonData.Status !== "-") {
            jsonData.rowStatus = jsonData.Status;
          } else {
            jsonData.rowStatus = undefined;
          }
          //&& this.record.optFileStatus == 1 删除提交状态数据编辑功能 2022/10/14
          if (jsonData.source != undefined) {
            this.updateData[item.id] = jsonData;
          }
          let newData = Object.assign({}, jsonData, item);
          delete newData.data;
          this.data.push(newData);
        });
        this.allData = this.data.concat([]);
      }
    },
    addJob() {
      this.$router.push("/job/add");
    },
    closeModel() {
      this.visible = false;
    },
    appoint() {
      this.isAppoint = 1;
      this.visible = true;
    },
    getOutFilePaths() {
      this.$get(
        "jobsvisualization/paths/" +
        this.record.jobsId +
        "/" +
        this.record.fileName
      ).then((res) => {
        this.outputFilePaths = res.data.data;
        this.outputFilePaths.fileType = this.record.fileType;
      });
    },
    loadPageData() {
      this.loading = true;
      this.getPageTextData();
    },
    getPageTextData() {
      let url = this.record.fileUrl;
      let optFileStatus = this.record.optFileStatus;
      let getUrl = "";
      if (!url) return;
      if (this.step === 1) {
        getUrl = "cloudPlatformApi/parseTxtFileToJSON";
      } else {
        getUrl = "cloudPlatformApi/parseTxtFileToJSON4View";
      }
      this.$get(getUrl, {
        fileUrl: url,
        userId: this.userId,
        pageSize: this.pageSize,
        pageNum: this.current + 1,
      }).then((res) => {
        if (res.data.code == 1) {
          let resData = res.data.data;
          this.pages = resData.page.pages;
          this.current = resData.page.current;
          resData.page.records.forEach((item, i) => {
            let jsonData = JSON.parse(item.data);
            if (jsonData.source != undefined && optFileStatus == 1) {
              this.updateData[item.id] = jsonData;
            }
            let newData = Object.assign({}, jsonData, item);
            delete newData.data;
            this.data.push(newData);
          });
          this.allData = this.data.concat([]);
          this.currentTotal = this.data.length;
        }
        this.loading = false;
      });
    },
    getTextData() {
      let url = this.record.fileUrl;
      let getUrl = "";
      if (!url) return;
      if (this.step === 1) {
        getUrl = "cloudPlatformApi/parseTxtFileToJSON";
      } else {
        getUrl = "cloudPlatformApi/parseTxtFileToJSON4View";
      }
      this.$get(getUrl, {
        fileUrl: url,
        userId: this.userId,
        ql: this.queryL,
        qs: this.queryS,
        qvc: this.queryVC,
        qgs: this.queryGS,
        qc: this.queryC,
        qg1s: this.queryG1S,
        qg2s: this.queryG2S,
        qfd: this.queryFD,
        geneA: this.queryGA,
        geneB: this.queryGB,
        type: this.queryType,
        rating: this.queryRating,
        functionalEffect: this.queryFE,
        pageSize: this.pageSize,
        pageNum: 1,
      }).then((res) => {
        this.textData = res.data.data;
        this.showTable = false;
        this.createColumns();
        if (this.textData.page) {
          this.pages = this.textData.page.pages;
          this.current = this.textData.page.current;
          this.total = this.textData.page.total;
          this.currentTotal = this.textData.page.records
            ? this.textData.page.records.length
            : 0;
        }
        setTimeout(() => {
          document
            .querySelectorAll(".ant-table-fixed-right .ant-table-fixed td")
            .forEach((ele) => {
              ele.onclick = (e) => {
                e.stopPropagation();
                e.cancelBubble = true;
              };
            });
          this.showTable = true;
        }, 1000);
      });
    },
    getData() {
      this.$get("joboutputfile/jobsFileRef/getRefDraftFileByJobId", {
        jobId: this.jobId,
      }).then((res) => {
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.output-page {
  width: 100%;
  min-width: 1200px;

  .hp-multiple-slt {
    min-width: 150px;
    margin-left: 10px;
  }

  /deep/ .ant-select-dropdown-menu {
    max-height: 150px;
  }

  .title {
    padding: 82px 0 56px 0;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }

  /deep/ .output-table {
    .ant-table-fixed-columns-in-body {
      div {
        display: none;
      }

      .down-list {
        width: 110px;
        display: block;
        height: 100%;
      }

      .ant-select {
        display: none;
      }
    }
  }

  .page-handle {
    height: 60px;
    background: #f8fbfb;
    padding: 0 40px;
    line-height: 60px;
    border-top: 1px solid rgba(240, 242, 245, 1);
    border-bottom: 1px solid rgba(240, 242, 245, 1);

    .align-right {
      text-align: right;
    }

    .hospital-dropdown-link {
      margin-left: 25px;
    }

    .hospital-dropdown-link {
      color: #3e7ff7;
      font-size: 14px;
    }

    .ant-btn+.ant-btn {
      margin-left: 5px;
    }
  }

  .page-trigger-lay,
  .page-trigger-search {
    clear: both;
    margin-top: 10px;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(228, 231, 237, 1);
    padding: 30px 40px;
    border-radius: 4px;
    position: relative;
  }

  .page-trigger-lay::before {
    content: "";
    position: absolute;
    top: -16px;
    left: 87px;
    width: 0px;
    height: 0px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent rgba(228, 231, 237, 1) transparent;
  }

  .page-trigger-lay::after {
    content: "";
    position: absolute;
    top: -14px;
    left: 87px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent white transparent;
  }

  .page-trigger-search::before {
    content: "";
    position: absolute;
    top: -16px;
    right: 80px;
    width: 0px;
    height: 0px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent rgba(228, 231, 237, 1) transparent;
  }

  .page-trigger-search::after {
    content: "";
    position: absolute;
    top: -14px;
    right: 80px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent white transparent;
  }

  .lay-content {
    line-height: 32px;

    .cbox-left {
      margin-left: 20px;
      min-width: 80px;
    }
  }

  .lay-c-search {
    padding-bottom: 10px;
    font-size: 12px;

    /deep/ .ant-input-affix-wrapper .ant-input {
      font-size: 12px;
    }
  }

  .lay-bottom {
    text-align: center;
    padding: 20px 0 0 0;
  }

  .breadcrumb {
    padding: 0 40px;
    height: 46px;
    line-height: 46px;
    background: #f8fbfb;

    /deep/ .ant-breadcrumb {
      display: inline-block;
    }
  }

  .page-content {
    padding: 20px 0;
    background: #fff;

    .edit_input_width {
      width: 100%;
    }

    .pagination {
      margin: 20px 0;
      text-align: right;
    }

    .bg-total {
      float: left;
      color: #a4a4a4;
    }

    .button-group {
      text-align: center;

      button {
        width: 330px;
        height: 42px;
        border: 1px solid rgba(66, 142, 247, 1);
        border-radius: 4px;
      }
    }
  }
}
</style>